import React from "react";
import toast, { Toaster } from "react-hot-toast";
import useAllScreenSize from "../hooks/useAllScreenSize";
import useCssProperty from "../hooks/useCssProperty";
import * as Const from "./../_Const";

const ToasterBar = () => {
  const screenType = useAllScreenSize();
  const bgColor = useCssProperty("--color-accent-dark");

  function getCssFor(what) {
    console.log(screenType);

    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "x":
          css = 75;
          break;
        case "padding":
          css = "8px";
          break;
        case "radius":
          css = "10px";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2 || screenType === Const.SCREEN_TV_720 || screenType === Const.SCREEN_TV_768) {
      switch (what) {
        case "x":
          css = 120;
          break;
        case "padding":
          css = "16px";
          break;
        case "radius":
          css = "16px";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "x":
          css = 120;
          break;
        case "padding":
          css = "16px";
          break;
        case "radius":
          css = "24px";
          break;
      }
    } else if (screenType === Const.SCREEN_TV_1080) {
      switch (what) {
        case "x":
          css = 120;
          break;
        case "padding":
          css = "24px";
          break;
        case "radius":
          css = "24px";
          break;
      }
    } else if (screenType === Const.SCREEN_TV_2160) {
      switch (what) {
        case "x":
          css = 120;
          break;
        case "padding":
          css = "56px";
          break;
        case "radius":
          css = "48px";
          break;
      }
    } else if (screenType === Const.SCREEN_PHONE) {
      switch (what) {
        case "x":
          css = 120;
          break;
        case "padding":
          css = "16px";
          break;
        case "radius":
          css = "24px";
          break;
      }
    }
    //console.log(what, screenType, css);

    return css;
  }

  if (screenType === Const.SCREEN_UNKNOWN) {
    return;
  }
  return (
    <Toaster
      containerClassName="bg-whitea"
      containerStyle={{
        top: getCssFor("x"),
        left: getCssFor("x"),
        bottom: getCssFor("x"),
        right: getCssFor("x"),
      }}
      toastOptions={{
        position: "bottom-center",
        className: "text-base scRPIV2:text-lg scWaveShare:text-xl tvFullHD:text-2xl tv4K:text-6xl",
        style: {
          borderRadius: getCssFor("radius"),
          background: bgColor,
          maxWidth: "100%",
          color: "#fff",
          padding: getCssFor("padding"),
        },
      }}
    />
  );
};

export default ToasterBar;
